import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import './DropdownNav.css'

function DropdownNav() {

  const [open, setOpen] = useState(false);

  let menuRef = useRef();

  useEffect(() => {
    let handler = (e)=>{
      if(!menuRef.current.contains(e.target)){
        setOpen(false);
      }
    };

    document.addEventListener("click", handler);
    document.addEventListener("touchstart", handler);


    return() =>{
      document.removeEventListener("click", handler);
      document.removeEventListener("touchstart", handler);
    }

  });

  return (
    <div className="DropdownNav">
      <div className='menu-container' ref={menuRef}>
        <button
          className='menu-trigger'
          onClick={()=>{setOpen(!open)}}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <nav className={`dropdown-menu ${open? 'active' : 'inactive'}`} aria-label="Mobile navigation">
          <ul role="menu">
            <li role="none"><Link className='dropdown-link' to='/' role="menuitem">Home</Link></li>
            <li role="none"><Link className='dropdown-link' to='/services' role="menuitem">Business Services</Link></li>
            <li role="none"><Link className='dropdown-link' to='/homesupport' role="menuitem">Residential Support</Link></li>
            <li role="none"><Link className='dropdown-link' to='/itconsulting' role="menuitem">IT Consulting</Link></li>
            <li role="none"><Link className='dropdown-link' to='/thedifference' role="menuitem">An Orchestrated Difference</Link></li>
            <li role="none"><Link className='dropdown-link' to='/contact' role="menuitem">Contact</Link></li>
          </ul>
        </nav>
      </div>
    </div>
  );
}



export default DropdownNav;